import styled, { css } from "styled-components";

/** Aparência do campo: padrão (busca da home) ou "bar" (barra de alertas, sem borda). */
export type FieldSearchVariant = "default" | "bar";

/**
 * Container principal do FieldSearch (Desktop)
 * Configura o layout e a posição do componente.
 */
export const FieldSearchContent = styled.div<{ $variant?: FieldSearchVariant }>`
  padding: ${({ theme }) => theme.spacing(0)};
  position: relative;

  ${({ $variant }) =>
    $variant === "bar" &&
    css`
      height: 100%;
    `}
`;

/**
 * Ícone do campo na variante "bar".
 * O atom Icon fixa a cor do glifo, então a cor é forçada pelos descendentes.
 */
export const FieldSearchBarIcon = styled.span<{ $muted?: boolean }>`
  display: flex;
  flex-shrink: 0;
  color: ${({ theme, $muted }) =>
    $muted ? theme.colors.darkGray : theme.colors.cyan};

  & div {
    color: inherit;
  }
`;

/**
 * Campo de busca (Desktop)
 * Organiza os ícones e o campo de entrada.
 */
export const FieldSearch = styled.div<{ $variant?: FieldSearchVariant }>`
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;
  display: flex;
  height: 100%;

  & > svg {
    flex-shrink: 0;
    height: ${({ theme }) => theme.spacing(4)};
    width: ${({ theme }) => theme.spacing(4)};

    &:first-child {
      margin-top: 2px;
    }
  }

  ${({ $variant }) =>
    $variant === "bar" &&
    css`
      padding: 0;
      gap: ${({ theme }) => theme.spacing(2)};
      height: 100%;
      min-height: 0;
    `}
`;

/**
 * Dropdown do FieldSearch (Desktop)
 * Configura o dropdown de sugestões com tamanhos e tipos.
 */
export const FieldSearchDropdown = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    !["type", "$fullWidth", "$variant"].includes(prop),
})<{ type: string; $fullWidth?: boolean; $variant?: FieldSearchVariant }>`
  position: absolute;
  min-width: ${({ type, theme, $fullWidth }) => {
    if ($fullWidth) return "0";
    return type === "origin" ? theme.spacing(38) : theme.spacing(60);
  }};
  ${({ $fullWidth }) =>
    $fullWidth &&
    `
    left: 0;
    right: 0;
  `}
  padding-top: ${({ theme }) => theme.spacing(1)};
  z-index: ${({ $variant }) => ($variant === "bar" ? 1000 : 10)};
`;
